// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  FeatureHub
} from './';

export default {
  path: 'subscriptions',
  childRoutes: [
    { path: 'features', component: FeatureHub },
    { path: 'features/:tabId', component: FeatureHub },
  ],
};
